module.exports = __webpack_public_path__ + "img/TL.79485df4.png";